<!-- Wrapper -->
<div class="slide_container" [@slide]="{value: slideState, params: {renderContent: slideConfig.contentDisplay, time: slideConfig.animationConfig.time, function: slideConfig.animationConfig.function}}">
  <!-- content with DOM PERFORMANCE -->
  <ng-container *ngIf="isOpen">
    <!-- proyeccion -->
    <ng-content *ngIf="!template"></ng-content>
    <ng-template *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="templateData"></ng-template>
  </ng-container>
</div>